<template>
  <div ref="appContent" class="app-content">
    <el-card shadow="never" class="aui-card--fill">
      <div class="mod-trade__agreement}">
        <el-form
            :inline="true"
            :model="dataForm"
            @keyup.enter.native="getDataList()"
            ref="queryForm"
            class="query-form"
        >
          <el-form-item label="外销合同编号：">
            <order-drop v-model="dataForm.agreementCode"></order-drop>
          </el-form-item>
          <el-form-item label="工厂/供应商：">
            <factory
                v-model="dataForm.factoryId"
                @change="reload"
                :clearable="true"
                :showBtn="false"
            ></factory>
          </el-form-item>
          <el-form-item>
            <el-checkbox v-model="pageConfig.showDetail">显示明细</el-checkbox>
          </el-form-item>
          <el-form-item>
            <el-button @click="reload()" size="mini">{{ $t('query') }}</el-button>
          </el-form-item>
        </el-form>
        <div class="table-bar" style="justify-content: left;">
          <div class="bar-item">
            <el-button @click="showMakeSaveDialog()" size="mini" type="primary" icon="el-icon-plus">创建加工单
            </el-button>
          </div>
          <div class="bar-item">
            <el-button @click="showTechnologyDialog()" size="mini" type="warning" icon="el-icon-plus">设置工艺
            </el-button>
          </div>
          <div class="bar-item">
            <el-button type="danger" size="mini" @click="showExportDialog()" icon="el-icon-download">下载合同
            </el-button>
          </div>
          <div class="bar-item">
            <el-button type="danger" size="mini" v-if="$hasPermission('erp:make:check')" @click="doCheck()"
                       icon="el-icon-s-promotion">发送加工单
            </el-button>
          </div>
          <el-button class="bar-item" type="warning" size="mini" v-if="$hasPermission('erp:make:cancel:send')"
                     @click="cancelSendStatus()"
                     icon="el-icon-s-promotion">撤回已发送订单
          </el-button>
        </div>
        <el-table
            ref="table"
            v-loading="dataListLoading"
            :data="dataList"
            border
            @selection-change="dataListSelectionChangeHandle"
            style="width: 100%"
            @row-click="rowClickHandle"
            :max-height="maxTableHeight"
            :highlight-current-row="true"
        >
          <el-table-column
              type="selection"
              header-align="center"
              align="center"
              width="50"
          ></el-table-column>
          <el-table-column
              type="index"
              header-align="center"
              align="center"
              label="行号"
              width="50"
          ></el-table-column>
          <el-table-column
              prop="agreementCode"
              label="外销合同编号"
              header-align="center"
              align="center"
          ></el-table-column>
          <el-table-column
              prop="code"
              label="批次号"
              header-align="center"
              align="center"
              width="120"
          ></el-table-column>
          <el-table-column
              label="工厂名称"
              header-align="center"
              align="center"
              min-width="140"
              prop="companyName"
              :show-overflow-tooltip="true"
          >
          </el-table-column>
          <el-table-column
              prop="productCount"
              label="产品数"
              header-align="center"
              align="center"
              width="80"
          ></el-table-column>
          <el-table-column
              prop="totalCount"
              label="总件数"
              header-align="center"
              align="center"
              width="80"
          ></el-table-column>
          <el-table-column
              prop="technologyName"
              label="工艺"
              header-align="center"
              align="center"
          ></el-table-column>
          <el-table-column
              prop="creatorName"
              label="制单人"
              header-align="center"
              align="center"
              width="80"
          ></el-table-column>
          <el-table-column
              prop="createDate"
              label="制单时间"
              header-align="center"
              align="center"
              width="160"
          ></el-table-column>
          <el-table-column
              prop="makeType"
              label="加工类型"
              header-align="center"
              align="center"
              width="90"
          ></el-table-column>
          <el-table-column
              label="状态"
              header-align="center"
              align="center"
              width="80"
          >
            <template #default="{row}">
              <send-status :status="row.status"></send-status>
            </template>
          </el-table-column>
          <el-table-column
              :label="$t('handle')"
              header-align="center"
              align="center"
              width="200"
              fixed="right"
          >
            <template slot-scope="scope">
              <el-button type="text" size="mini" @click="doCopy(scope.row)" class="txtBtn"
                         icon="el-icon-edit-outline">复制
              </el-button>
              <!--              <el-button type="text" size="mini" @click="showChargeDialog(scope.row)" class="txtBtn"-->
              <!--                         icon="el-icon-edit-outline">费用管理-->
              <!--              </el-button>-->
              <el-button type="text" size="mini"
                         v-if="checkCanEdit(scope.row)" class="txtBtn" @click="showMakeSaveDialog(scope.row)"
                         icon="el-icon-edit-outline">修改
              </el-button>
              <el-button type="text" size="mini"
                         v-if="$hasPermission('trade:factorymake:delete')&&scope.row.status===$const.MakeStatus.NEW"
                         @click="doDel(scope.row)"
                         class="txtBtn"
                         icon="el-icon-edit-outline"
              >删除
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            :current-page="page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="limit"
            :total="total"
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="pageSizeChangeHandle"
            @current-change="pageCurrentChangeHandle"
        >
        </el-pagination>
      </div>
    </el-card>
    <el-card v-if="pageConfig.showDetail">
      <div slot="header" class="card-header">
        <div>加工单明细</div>
      </div>
      <MakeDetailTable ref="MakeDetailTable" :height="maxTableHeight"
                       :default-query-params="{makeId:currentId,page:1,limit:10000,showCompletedOrder:true}"
                       :is-page="false" :show-query="false" :auto-load="false"
                       :hide-columns="['orderCode','customerName']"
                       :price-detail="true" :show-tool="false"></MakeDetailTable>
    </el-card>
    <DetailDialog ref="detailDialog"></DetailDialog>
    <CheckInDialog
        ref="checkInDialog"
        @refreshDataList="getDataList"
    ></CheckInDialog>
    <ExportDialog ref="exportDialog"></ExportDialog>
    <technology-dialog ref="TechnologyDialog" @refreshDataList="getDataList"></technology-dialog>
    <ChargeDialog ref="ChargeDialog" @changed="$refs.detailList.getDataList()"></ChargeDialog>
    <MakeSaveDialog ref="MakeSaveDialog" @changed="()=>{this.currentId='';this.getDataList()}"></MakeSaveDialog>
  </div>
</template>

<script>
import MakeSaveDialog from '@/views/modules/erp/make/save-dialog.vue'
import SendStatus from '@/views/modules/erp/common/send-status.vue'
import ChargeDialog from '@/views/modules/erp/make/charge-dialog.vue'
import CheckInDialog from './check-in'
import DetailDialog from './detail-dialog.vue'
import DetailList from './detail-list.vue'
import mixinViewModule from '@/mixins/view-module'
import ExportDialog from './export-dialog'
import TechnologyDialog from '@/views/modules/trade/factory-make/technology-dialog.vue'
import MakeDetailTable from '@/components/MakeDetailTable.vue'

export default {
  mixins: [mixinViewModule],
  components: {
    DetailList,
    DetailDialog,
    CheckInDialog,
    ExportDialog, TechnologyDialog, ChargeDialog, MakeDetailTable, SendStatus, MakeSaveDialog
  },
  data () {
    return {
      dateArr: [],
      currentId: '',
      pageConfig: {
        showDetail: true,
        pageHeight: 0
      },
      mixinViewModuleOptions: {
        getDataListURL: '/trade/factorymake/page',
        getDataListIsPage: true,
        exportURL: '/trade/factorymake/export',
        deleteURL: '/trade/factorymake',
        deleteIsBatch: true,
      },
      dataForm: {
        id: '',
        beginDate: '',
        endDate: '',
        agreementCode: '',
        code: '',
        factoryId: '',
      },
      maxTableHeight: 100,
    }
  },
  activated () {
    this.pageConfig.pageHeight = this.$refs.appContent.clientHeight -
        this.$refs.queryForm.$el.clientHeight
  },
  watch: {
    currentId (newVal) {
      if (newVal) {
        this.$refs.MakeDetailTable.reload()
      } else {
        this.$refs.MakeDetailTable.clear()
      }
    },
    'pageConfig.showDetail': {
      handler: function (newVal) {
        this.$nextTick(() => {
          let tableCount = 1
          let baseHeight = this.pageConfig.pageHeight
          if (newVal) {
            tableCount = 2
            baseHeight -= 150
          } else {
            tableCount = 1
            baseHeight -= 60
          }
          this.maxTableHeight = baseHeight / tableCount
        })
      },
      immediate: true
    },
    dateArr (newVal) {
      if (newVal && newVal.length === 2) {
        this.dataForm.beginDate = newVal[0]
        this.dataForm.endDate = newVal[1]
      } else {
        this.dataForm.beginDate = ''
        this.dataForm.endDate = ''
      }
      this.currentId = ''
      this.reload()
    },
  },
  computed: {
    isAdmin () {
      let currentUser = this.$store.state.user
      if (currentUser.roleIdList.find(r => r === '1497144338753867777')) {
        return true
      }
      return false
    },
  },
  methods: {
    showMakeSaveDialog (row) {
      this.$refs.MakeSaveDialog.init(row ? row.id : null)
    },
    cancelSendStatus () {
      let rows = this.dataListSelections
      if (this.$c.isArrayEmpty(rows)) {
        return this.$message.error('请选择要操作的数据')
      }
      this.$confirm(`是否取消【${rows.length}】个加工单的发货状态？`, '操作提示').then(() => {
        this.$api2.post(`/erp/make/cancel/send`, { ids: rows.map(item => item.id) }).then(res => {
          this.$refs.table.clearSelection()
          this.getDataList()
        })
      })
    },
    doDel (row) {
      this.$confirm(`是否要删除【${row.agreementCode}】下【${row.companyName}】的加工单？`, `操作提示`).then(() => {
        this.$api2.delete(`/erp/make`, { data: [row.id] }).then(res => {
          this.getDataList()
          this.$c.success('删除成功')
        })
      })
    },
    checkCanEdit (row) {
      if (!this.$hasPermission('trade:factorymake:delete')) {
        return false
      }
      if (this.isAdmin) {
        return true
      }
      if (row.status === this.$const.MakeStatus.NEW) {
        return true
      }
      return false
    },
    doCheck () {
      if (this.$c.isArrayEmpty(this.dataListSelections)) {
        return this.$message.error('请选择要发送的加工单')
      }
      this.$confirm(`是否要将【${this.dataListSelections.length}】个加工单发送给供应商？发送后加工单将无法修改和删除！`).then(() => {
        this.$api2.post(`/erp/make/check`, { ids: this.dataListSelections.map(item => item.id) }).then(res => {
          this.$refs.table.clearSelection()
          this.getDataList()
          this.$message.success('操作成功')
        })
      })
    },
    //显示工艺设置弹窗
    showTechnologyDialog () {
      if (this.dataListSelections.length === 0) {
        return this.$c.error('请选择要设置工艺的合同')
      }
      this.$refs.TechnologyDialog.makeIds = this.dataListSelections.map(item => item.id)
      this.$refs.TechnologyDialog.init()
    },
    async doCopy (row) {
      try {
        await this.$confirm('是否复制该加工订单？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        const { data: res } = await this.$http.post(`/trade/factorymake/copy`, { id: row.id })
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.getDataList()
        this.showMakeSaveDialog(res.data)
      } catch (e) {
        console.log(e)
      }
    },
    showExportDialog () {
      if (this.dataListSelections.length === 0) {
        return this.$c.error('请选择下载合同内容')
      }
      let companyId = this.dataListSelections[0].companyId
      for (let i = 1; i < this.dataListSelections.length; i++) {
        let item = this.dataListSelections[i]
        if (item.companyId !== companyId) {
          return this.$message.error('选择的合同不属于同一工厂')
        }
      }
      this.$refs.exportDialog.ids = this.dataListSelections.map(item => item.id).join(',')
      this.$refs.exportDialog.init()
    },
    // 批量导入开始
    showCommonDialog () {
      this.$refs.commonUpload.init()
    },
    showCheckInDialog (row) {
      this.$refs.checkInDialog.id = row.id
      this.$refs.checkInDialog.init()
    },
    beforeTableBinding (dataList) {
      if (!dataList || dataList.length === 0) {
        this.currentId = ''
        return
      }
      this.currentId = dataList[0].id
      dataList.forEach(row => {
        if (row.harbours) {
          row.receiver = row.harbours
        } else if (row.receiverList) {
          row.receiver = row.receiverList.map(r => r.name).join(',')
        }
      })
    },
    showDetailDialog (row) {
      this.$refs.detailDialog.id = row.id
      this.$refs.detailDialog.init()
    },
    rowClickHandle (row) {
      if (!row || !row.id) {
        this.currentId = ''
        return
      }
      this.currentId = row.id
    },
    addOrUpdateHandle (row) {
      let id = ''
      if (row) {
        id = row.id
      }
      this.$router.push(`/trade/agreement/save?id=${id}`)
    },
  },
}
</script>
